<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="widget">
          <div class="form-elements-sec">
            <div class="widget-title">
              <h3>Fakülte Ekle</h3>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="university">Üniversite</label>
                  <select class="form-control custom-input" v-model="university">
                    <option value selected disabled hidden>Seçiniz...</option>
                    <option
                      v-for="university in universities"
                      :key="university.id"
                      :value="university.id"
                    >{{ university.name }}</option>
                  </select>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="name">Fakülte Adı</label>
                  <input type="text" v-model="name" class="form-control custom-input">
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group">
                  <label for></label>
                  <button class="btn btn-success pull-right" @click="addData">Kaydet</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      name: "",
      university: "",
      universities: [],
      api: "faculties"
    };
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.$Progress.start();
      this.axios.get(this.api + '/create').then(response => {
        this.universities = response.data;
        this.$Progress.finish();
      });
    },
    addData() {
      this.$Progress.start();
      this.axios
        .post(this.api, {
          university: this.university,
          name: this.name
        })
        .then(response => {
          if (response.status == 201) {
            this.$router.push({
              name: "faculties.update",
              params: { id: response.data.id }
            });
          }
        });
    }
  }
};
</script>

<style scoped>
</style>